<ng-container *ngIf="isBuckaroo">
  Buckaroo
  <div id="idealQrButton"></div>
</ng-container>

<ng-container *ngIf="isPaypal">
  <ngx-paypal [config]="payPalConfig"></ngx-paypal>
</ng-container>
